import { render, staticRenderFns } from "./ModalExcluirUsuario.vue?vue&type=template&id=7da10aed"
import script from "./ModalExcluirUsuario.vue?vue&type=script&lang=js"
export * from "./ModalExcluirUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports